import React, {ReactElement, useEffect, useRef, useState} from 'react';
import {
  getStoreInformation,
  getAccessToken,
  getMetadata,
} from '../../../core/localstorage-data';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import RupeesIcon from '../../../assets/images/rupees.svg';
import EmptyCoupon from './EmptyCoupon';
import GreenIcon from '../../../assets/images/green_icon.svg';
import {
  orderResponse,
  applyCoupon,
  setLoaderType,
  resetNotification,
  removeCoupon,
  notification,
  setCouponApplied,
} from '../../../redux/orderSlice';

import './couponForm.css';

type Coupon = {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
};

type CouponFormProps = {
  type?: string;
  onDelete?: () => void;
  onApplyCoupon?: () => void;
  coupons: Coupon[];
};
const CouponForm: React.FC<CouponFormProps> = ({
  type,
  onDelete,
  coupons,
  onApplyCoupon,
}: CouponFormProps): ReactElement => {
  let BAG_PRICE = 0;
  const storeCode = `0${getStoreInformation().store_code}`;
  const accessToken = getAccessToken();
  const orderResp = useAppSelector(orderResponse);
  const notificationState = useAppSelector(notification);
  const [disabled, setDisabled] = useState(true);
  const [selected, setSelected] = useState('');
  const [selectedTextInput, setSelectedTextInput] = useState('');
  const [inputError, setInputError] = useState('');
  const [radioError, setRadioError] = useState('');
  const [appliedCouponID, setAppliedCouponID] = useState('');
  const [disableCheckButton, setDisableCheckButton] = useState(false);
  const [total, setTotal] = useState(0);
  const dispatch = useAppDispatch();
  const couponInput = useRef(null);

  useEffect(() => {
    getTotal();
  }, []);

  useEffect(() => {
    if (selectedTextInput === '') {
      setDisableCheckButton(true);
    }
  }, [selectedTextInput]);
  useEffect(() => {
    if (notificationState && notificationState.statusCode === '203') {
      getTotal();
      dispatch(resetNotification());
    }
  }, [notificationState]);

  function getTotal() {
    const metaData = getMetadata();
    const bagMetaData = metaData.find(
      (obj: {name: string}) => obj.name === 'bag-price',
    );
    if (bagMetaData) {
      BAG_PRICE = bagMetaData.value;
    }
    let totalMRP = 0;
    let promoDiscountAmount = 0;
    let bagPrice = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        totalMRP += item.sellPrice;
        promoDiscountAmount += item.promoDiscountAmount;
      });
    if (orderResp && orderResp.carryBagItem) {
      bagPrice = BAG_PRICE * orderResp.carryBagItem.quantity;
    }

    let couponTotalDiscount = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        if (item.couponDiscountAmount) {
          couponTotalDiscount += item.couponDiscountAmount;
        }
      });

    let totalAmount =
      orderResp && orderResp.itemList
        ? orderResp.itemList.reduce((prevAmount, item) => {
            return prevAmount + item.extSellPrice;
          }, 0)
        : 0;
    totalAmount = totalAmount + bagPrice;

    setTotal(Number(totalAmount));
  }

  useEffect(() => {
    if (orderResp !== null && orderResp.statusCode === '201') {
      dispatch(setLoaderType(''));
      if (
        orderResp &&
        orderResp.appliedCoupon &&
        orderResp.appliedCoupon.couponID === selectedTextInput &&
        appliedCouponID !== selectedTextInput
      ) {
        getTotal();
        setAppliedCouponID(selectedTextInput);
      }
      setInputError('');
      setRadioError('');
      setDisableCheckButton(true);
      // dispatch(setCouponApplied(true));
    } else if (orderResp && orderResp.statusCode === '401') {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          orderId: orderResp.orderId,
        },
      };
      dispatch(removeCoupon(parameters));
      if (selectedTextInput !== '') {
        setInputError(
          orderResp?.statusMessage || 'This coupon cannot be applied',
        );
      }
      if (selected !== '') {
        setRadioError(
          orderResp?.statusMessage || 'This coupon cannot be applied',
        );
      }
      dispatch(setLoaderType(''));
      dispatch(resetNotification());
    }
  }, [orderResp]);

  useEffect(() => {
    if (inputError !== '' || radioError !== '') {
      setDisabled(true);
    } else if (
      !orderResp?.appliedCoupon &&
      selectedTextInput === '' &&
      selected === ''
    ) {
      setDisabled(true);
    } else if (
      orderResp?.appliedCoupon &&
      (selectedTextInput !== '' || selected !== '')
    ) {
      setDisabled(false);
    } else setDisabled(true);
  }, [orderResp]);

  function handleCheckClick() {
    setInputError('');
    dispatch(setLoaderType('CouponGIFLoader'));
    callCouponAPI();
  }

  function callCouponAPI(value?: string) {
    dispatch(setCouponApplied(false));
    if (orderResp) {
      const parameters = {
        accessToken,
        payload: {
          storeCode: storeCode,
          orderId: orderResp?.orderId,
          couponId: value === undefined ? selectedTextInput : value,
        },
      };
      dispatch(applyCoupon(parameters));
    }
  }

  function handleCouponChange(event: any) {
    setInputError('');
    setRadioError('');
    setSelectedTextInput('');
    setSelected(event.target.value);
    dispatch(setLoaderType('CouponGIFLoader'));
    callCouponAPI(event.target.value);
  }
  console.log(
    orderResp && orderResp.appliedCoupon && orderResp.appliedCoupon.couponID,
  );
  console.log(appliedCouponID);

  return (
    <div className="overflow-y-auto" style={{height: 'calc(100% - 130px)'}}>
      <>
        <div className="relative ">
          <span className="text-xl block font-roboto text-left px-4 pt-6">
            Enter your coupon code
          </span>
        </div>
        <div className="pt-6 flex px-4">
          <div className="py-auto pt-4">
            <label className="radio-container ml-3">
              <input
                className={`${
                  inputError !== '' ? 'radio-text-error' : 'radio-text'
                }`}
                type="radio"
                name="radio-group"
                value={selectedTextInput}
                checked={selected === ''}
                id="textValue"
                onChange={() => {
                  setRadioError('');
                  setSelected('');
                  couponInput.current.focus();
                }}
              />
              <span className="checkmark"></span>
            </label>
          </div>
          <label htmlFor="textValue" className="w-full">
            <div
              className={`rounded-radius10 bg-blue_four flex justify-around ml-2 h-12 pr-4 items-center ${
                inputError !== '' ? 'border-solid border-red_zero' : ''
              }`}>
              <div className="flex flex-col">
                <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                  Coupon code
                </span>
                <div className="flex flex-col">
                  {
                    // selected === '' && (
                    <input
                      type="text"
                      placeholder="Enter coupon code"
                      className="focus:outline-none font-roboto ml-2.5 bg-transparent text-base"
                      value={selectedTextInput}
                      onFocus={() => {
                        setSelected('');
                      }}
                      ref={couponInput}
                      onChange={e => {
                        setInputError('');
                        setAppliedCouponID('');
                        setDisableCheckButton(false);
                        if (orderResp) {
                          if (orderResp.appliedCoupon) {
                            const parameters = {
                              accessToken,
                              payload: {
                                storeCode,
                                orderId: orderResp?.orderId,
                              },
                            };
                            dispatch(removeCoupon(parameters));
                          }
                        }
                        setRadioError('');
                        setDisableCheckButton(false);
                        setSelectedTextInput(e.target.value);
                        if (e.target.value.length === 0 && selected === '') {
                          setDisabled(true);
                        }
                      }}
                    />
                    // )
                    // ) : (
                    // <input
                    //   type="text"
                    //   placeholder="Enter coupon code"
                    //   className="focus:outline-none font-roboto ml-2.5 bg-transparent text-base"
                    //   readOnly
                    // />
                    // )}
                  }
                </div>
              </div>
              {disableCheckButton === false ? (
                <div onClick={handleCheckClick}>
                  <span className="text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold text-dark_red">
                    Check
                  </span>
                </div>
              ) : (
                <div className="cursor-not-allowed text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold text-green-600">
                  {orderResp &&
                  orderResp.appliedCoupon?.couponID === appliedCouponID ? (
                    <img src={GreenIcon} width="30" height="30" />
                  ) : (
                    <span className="cursor-not-allowed text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold text-dark_red">
                      Check
                    </span>
                  )}
                </div>
              )}
            </div>
            {inputError !== '' && (
              <div className="text-red-600 text-xs font-roboto pl-4 text-left">
                {inputError}
              </div>
            )}
          </label>
        </div>

        <div className="pt-6">
          <h2 className="w-full text-center border-b-solid border-b-1 border-b-black opacity-50 mt-2 mb-6 leading-dividing">
            <span className="bg-white px-2 font-bold">OR</span>
          </h2>
        </div>
        {coupons !== null && coupons.length > 0 ? (
          <div className="coupons pt-6 pb-8 px-4">
            <div className="font-roboto text-xl mb-4">
              Select your exclusive coupon
            </div>
            {coupons.map((coupon, index) => {
              return (
                <div className="py-2" key={index}>
                  <label
                    htmlFor={coupon.couponCode}
                    className="md:w-1/2 w-full">
                    <div
                      className={`rounded-radius10 flex justify-around ml-2 ${
                        radioError !== '' ? 'border-solid border-red_zero' : ''
                      }`}>
                      <div className="flex">
                        <div className="py-auto pt-4 pl-1">
                          <label className="radio-container">
                            <input
                              className={`${
                                radioError !== '' ? 'radio-error' : 'radio-text'
                              }`}
                              type="radio"
                              name="radio"
                              value={coupon.couponCode}
                              checked={selected === coupon.couponCode}
                              id={coupon.couponCode}
                              onChange={event => handleCouponChange(event)}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                        <div className="flex flex-col">
                          <div className=" flex items-center">
                            <div className="text-black_zero rounded-l-radius10 items-center pl-4 bg-blue_four  w-3/4 text-xs text-left font-roboto ml-2.5 font-bold h-full p-2 inline-block break-all">
                              {coupon.description}
                            </div>
                            <div className="text-black_zero rounded-r-radius10 items-center pl-2 pr-1 text-xs text-left font-roboto font-bold  bg-black_two h-full w-28p p-2 inline-block break-all">
                              {coupon.couponCode}
                            </div>
                          </div>
                          {radioError !== '' &&
                            selected === coupon.couponCode && (
                              <div className="text-red-600 mt-2 pl-4 text-xs font-roboto text-left">
                                {radioError}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              );
            })}
          </div>
        ) : (
          <EmptyCoupon />
        )}
      </>
      <div className="mt-10 fixed left-0 right-0 bottom-0 coupon-total py-6 px-6">
        <div className="flex justify-between">
          <div>Total</div>
          <div className="flex items-center">
            <span>
              <img src={RupeesIcon} />
            </span>
            <span>{total.toFixed(2)}</span>
          </div>
        </div>
        <div className="border-b-1 border-solid border-black border-opacity-50"></div>
        <div>
          <button
            className="text-white h-12 cursor-none-allowed rounded-radius10 mt-2 grid place-items-center focus:outline-none text-center primary normal w-full"
            disabled={disabled}>
            <p className="font-bold font-roboto" onClick={onApplyCoupon}>
              Apply Coupon
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};
export default CouponForm;
